import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { endpoints } from 'Core/defaultValues';
import { useNavigate } from "react-router-dom";
import { HasPermission } from "Core/security";


let domains = {
  driveri: "https://driveri.monarchtracking.com/console/#/login",
  eld: "https://eld.azuga.com/portal/login.html",
  classic: "https://auth.secureserviceweb.com/oauth2/authorize?response_type=code&redirect_uri=https%3A%2F%2Fportal.monarchtracking.com%2Fopenid%2Flogin.php&client_id=3af67b68-6051-4919-87d2-58c5d95b1337&nonce=0b74174252b98e30a0aaf5090a29b3cd&state=eaf118602ac6c9a7bc8265afb5772b60&scope=offline_access+openid",
  ditat: "https://ng01.ditat.net/login",
  intangles: "https://monarch.intangles.us",
  xbiplus: "https://xbiplus.com/login"
}

const MonarchIframes = () => {
  const pathname = window.location.pathname;
  const pathnameSplit = pathname.split('/')
  let url = domains[pathnameSplit[pathnameSplit.length - 1]]
  const navigate = useNavigate()

  const user = useSelector(state => state.securityRedux.user)


  useEffect(() => {
    let permission = ''
    //validate permissions
    if (url == domains.driveri) {
      permission = 'mdriveri'
    }
    else if (url == domains.eld) {
      permission = 'meld'
    }
    else if (url == domains.classic) {
      permission = 'mclassic'
    }
    else if (url == domains.ditat) {
      permission = 'mditat'
    }
    else if (url == domains.intangles) {
      permission = 'intangles'
    } else if (url == domains.xbiplus) {
      permission = 'xbiplus'
    }

    if (!HasPermission(user, permission) || permission == '') {
      navigate("/error");
    }
  }, [url])

  return (
    <div style={{ height: "98vh" }}>
      <iframe
        id="monarch"
        title="monarch"
        width="100%"
        height="100%"
        src={url}
      />
    </div>
  );
};

export default MonarchIframes;
